import React, { Dispatch, SetStateAction } from 'react';
import { AvButton } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

interface SelectAllRowsButtonProps {
  width?: number;
  colspan: number;
  totalRows: number;
  currentPageRows: number;
  onClearSelection: () => void;
  onSelectAllRows: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  isClickedAll: boolean;
  setAllClicked: Dispatch<SetStateAction<boolean>>;
}

export const SelectAllRowsButton: React.FC<SelectAllRowsButtonProps> = ({
  colspan,
  totalRows,
  currentPageRows,
  onClearSelection,
  onSelectAllRows,
  width,
  isClickedAll,
  setAllClicked,
}) => (
  <TableRow>
    <TableCell colSpan={colspan} align="center" sx={{ background: 'var(--color-surface-base-secondary)' }}>
      <Box sx={{ ...flex.center, gap: 1, width }}>
        {!isClickedAll ? (
          <>
            You selected all {currentPageRows} rows on this page.{' '}
            <AvButton
              variant="primaryText"
              size="xSmall"
              onClick={e => {
                onSelectAllRows(e);
                setAllClicked(true);
              }}>
              {' '}
              Select all {totalRows.toLocaleString()} rows
            </AvButton>
          </>
        ) : (
          <>
            You selected all {totalRows}{' '}
            <AvButton variant="primaryText" size="xSmall" onClick={onClearSelection}>
              Clear Selection
            </AvButton>
          </>
        )}
      </Box>
    </TableCell>
  </TableRow>
);
